export default "__VITE_ASSET__4fe0ad6c__"